import * as React from "react";
import type { SVGProps } from "react";
const SvgIconChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38.68c-1.6.1-3.17.63-4.5 1.51-1.07.7-1.99 1.63-2.69 2.69-.57.86-1.02 1.9-1.26 2.88-.52 2.14-.28 4.39.68 6.34.1.19.22.44.3.55l.11.21-.67 1.8-.68 1.79v.17c0 .15 0 .19.06.3q.1.23.35.35c.2.1.2.1 2.74-.36 1.83-.33 2.3-.41 2.34-.4 1 .42 1.63.6 2.48.73 1.88.27 3.73-.02 5.41-.83.99-.48 1.78-1.04 2.55-1.81 1.35-1.35 2.26-3.07 2.59-4.93.35-1.96.08-3.95-.78-5.72-.48-.99-1.04-1.78-1.81-2.55Q15 1.78 12.8 1.1C11.75.74 10.53.6 9.39.67m.01 1.43c-2.4.2-4.61 1.48-5.95 3.48Q2.4 7.13 2.14 9.04c-.04.38-.05 1.53 0 1.91q.24 1.73 1.09 3.12c.3.5.34.62.3.84L3 16.34l-.5 1.34s.82-.13 1.8-.31c2.13-.4 2-.38 2.37-.2q1.04.5 2.32.67c.28.04.4.05 1.01.05.75 0 .94-.02 1.53-.13.7-.14 1.29-.34 1.96-.67.81-.4 1.46-.86 2.1-1.5s1.1-1.29 1.5-2.1c.33-.67.53-1.26.67-1.96.11-.59.13-.78.13-1.53s-.02-.94-.13-1.53c-.14-.7-.34-1.29-.67-1.96-.4-.81-.86-1.46-1.5-2.1s-1.29-1.1-2.1-1.5-1.54-.62-2.46-.75c-.22-.03-.42-.04-.91-.05z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconChat;
